


export class BrowserAppEvaluationToolInfo {

  public version = '2024.3.20.1';

  constructor() {
  }

}
